var map = {
	"./2025-09-04 14.41.41.jpg": 9024,
	"./2025-09-04 14.42.11.jpg": 7003,
	"./2025-09-04 14.45.19.jpg": 5334,
	"./about-me.jpg": 6072,
	"./alina-lay.png": 8541,
	"./basketball.jpg": 5337,
	"./basketball.webp": 6684,
	"./before-after/IMG_6223.JPG": 448,
	"./before-after/IMG_6224.JPG": 134,
	"./before-after/IMG_6225.JPG": 3269,
	"./before-after/IMG_6226.JPG": 6778,
	"./before-after/IMG_6227.JPG": 81,
	"./before-after/IMG_6228.JPG": 5981,
	"./before-after/IMG_6229.JPG": 8936,
	"./before-after/IMG_6231.JPG": 4049,
	"./before-after/IMG_6264.JPG": 5572,
	"./before_pro.jpg": 5409,
	"./before_pro_2.jpg": 258,
	"./beforeafter/1.jpg": 5216,
	"./beforeafter/2.jpg": 6000,
	"./beforeafter/3.jpg": 9365,
	"./beforeafter/4.jpg": 4990,
	"./beforeafter/5.jpg": 8345,
	"./beforeafter/6.jpg": 6139,
	"./hero-bg-mobile.jpg": 8501,
	"./how-pass-course.png": 185,
	"./how-pass.png": 4869,
	"./pro-hero-bg.jpg": 3247,
	"./pro-hero-subscribe.png": 7656,
	"./pro/1.png": 1191,
	"./pro/2.png": 6132,
	"./pro/3.png": 4309,
	"./pro/4.png": 1655,
	"./pro/5.png": 6858,
	"./pro/6.png": 9752,
	"./pro/7.png": 5242,
	"./pro/infography-mobile.svg": 8297,
	"./pro/infography.svg": 2534,
	"./pro/logos/bazaar.png": 5929,
	"./pro/logos/cosmo.png": 619,
	"./pro/logos/elle.png": 8436,
	"./pro/logos/grazia.png": 9229,
	"./pro/logos/instyle.png": 6678,
	"./pro/logos/peopletalk.png": 7126,
	"./qa.png": 4320,
	"./results.png": 4666,
	"./results/18.svg": 3573,
	"./results/back_side.svg": 8944,
	"./results/body.svg": 1826,
	"./results/charger/18.svg": 7118,
	"./results/charger/brain.svg": 5073,
	"./results/charger/drop.svg": 3632,
	"./results/charger/hands-up.svg": 6775,
	"./results/charger/heart.svg": 9789,
	"./results/charger/immunity.svg": 4840,
	"./results/charger/stomach.svg": 4369,
	"./results/charger/strong.svg": 6172,
	"./results/chat.svg": 6295,
	"./results/cycle.svg": 5226,
	"./results/edema.svg": 7635,
	"./results/face.svg": 1234,
	"./results/flash.svg": 977,
	"./results/fork_spoon.svg": 7349,
	"./results/heart.svg": 7011,
	"./results/immune-system.svg": 5032,
	"./results/immune.svg": 2327,
	"./results/leafs.svg": 7253,
	"./results/lungs.svg": 8243,
	"./results/metabolic.svg": 7636,
	"./results/posture.svg": 1177,
	"./results/pregnant.svg": 6435,
	"./results/stamina.svg": 1834,
	"./results/stand.svg": 2385,
	"./results/stomach.svg": 3920,
	"./results/yoga.svg": 3200,
	"./rules.png": 1161,
	"./testimonials.png": 8133,
	"./testimonials/ava-1.jpeg": 389,
	"./testimonials/ava-2.jpeg": 6098,
	"./testimonials/ava-3.jpeg": 5544,
	"./testimonials/ava-4.jpeg": 3196,
	"./testimonials/ava-5.jpeg": 6565,
	"./testimonials/ava-6.jpeg": 1584,
	"./testimonials/ava-7.jpeg": 4338,
	"./testimonials/ava-8.jpeg": 8086,
	"./testimonials/review-avatar-1.png": 6391,
	"./title-bodyflex.svg": 593,
	"./title-charger.svg": 7121,
	"./title-oxycise.svg": 884,
	"./title-second.svg": 2195
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4848;